import React from 'react'

import { range } from 'lodash'

const ADJACENT_ITEMS = 2

const BASE_STYLE = { marginLeft: '0.2em', marginRight: '0.2em' }
const ACTIVE_STYLE = { ...BASE_STYLE }
const INACTIVE_STYLE = { ...BASE_STYLE, cursor: 'pointer', textDecoration: 'underline' }

interface PaginationProps {
  currentPage: number,
  maxPage: number,
  totalResults: number,
  changePage: (pageNumber: number) => void
}

export const Pagination = ({ currentPage, maxPage, totalResults, changePage }: PaginationProps) => {
  const Item = ({ page }: {page: number}) => (
    <span
      style={currentPage === page ? ACTIVE_STYLE : INACTIVE_STYLE}
      onClick={() => changePage(page)}
    >
      {page}
    </span>
  )

  const SummaryDisplay = () => (
    <>
      {totalResults} Results
      {' '}|{' '}
      Showing Page {currentPage} of {Math.max(maxPage, 1)}
      {' '}|{' '}
    </>
  )

  if (maxPage <= 5) {
    return (
      <div id="pageinforesults">
        <SummaryDisplay />
        {range(1, maxPage + 1).map(x =>
          <Item key={x} page={x} />
        )}
      </div>
    )
  }

  return (
    <div id="pageinforesults">
      <SummaryDisplay />
      <span onClick={() => changePage(1)} style={INACTIVE_STYLE}>« First</span>
      {currentPage > 1 &&
        <span onClick={() => changePage(currentPage - 1)} style={INACTIVE_STYLE}>‹ Previous</span>
      }
      {currentPage > ADJACENT_ITEMS + 1 &&
        <span>...</span>
      }
      {range(
        Math.max(currentPage - ADJACENT_ITEMS, 1),
        Math.min(currentPage + ADJACENT_ITEMS + 1, maxPage + 1)
      ).map(x =>
        <Item key={x} page={x} />
      )}
      {maxPage - currentPage > ADJACENT_ITEMS &&
        <span style={BASE_STYLE}>...</span>
      }
      {currentPage < maxPage &&
        <span onClick={() => changePage(currentPage + 1)} style={INACTIVE_STYLE}>Next ›</span>
      }
      <span onClick={() => changePage(maxPage)} style={INACTIVE_STYLE}>Last »</span>
    </div>
  )
}
